import { FC } from 'react'

import { useCountDown } from '../../features/apply/hooks/useCountDown'

export interface IKlassTimer {
  expiryTimestamp: number
}

const BasicTimer: FC<IKlassTimer> = ({ expiryTimestamp }) => {
  const {
    format,
    timeUnit,
    isLeftApplyDurationThreeDays,
    isLeftApplyDurationSevenDays,
  } = useCountDown(expiryTimestamp)
  return (
    <div
      className={`mt-4 hidden rounded-lg border border-gray-300 ${
        isLeftApplyDurationSevenDays ? 'lg:block' : ''
      }`}>
      <div className="py-4 text-center">
        <p className="text-sm text-gray-500">지원 마감까지</p>
        <div
          className={`my-1 flex justify-center space-x-1.5 font-semibold ${
            isLeftApplyDurationThreeDays ? 'text-red-500' : 'text-gray-500'
          }`}>
          {format.map((time, idx) => (
            <div className="rounded bg-gray-100 px-2 py-1" key={`timeFormat_${idx}`}>
              <span>
                {time}
                {timeUnit[idx]}
              </span>
            </div>
          ))}
        </div>
        <p className="text-sm text-gray-500">남았습니다.</p>
      </div>
    </div>
  )
}

export default BasicTimer
